import React, {Component} from "react";
import {Alert, FormGroup, Row, Col, Label, Modal, Button} from "reactstrap";
import {Formik, Field, Form, ErrorMessage} from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import {groupsNew, groupsEdit} from "../../store/groups/actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {capitalizeFirst, removeEmptyFormField} from "../../common/general";

class NewModal extends Component {
  constructor(props) {
    super(props)
    this.state = {loading: false, error: ""}
  }

  onClose = () => {
    this.props.togModal()
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({loading: this.props.loading, response: this.props.response, error: this.props.error});
      if (this.props.response.status === 0) {
        this.props.refreshParent({history: this.props.history})
        this.onClose()
      }
    }
  }

  render() {
    const requiredName = Yup.string().required("Please Enter Group Name")

    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {capitalizeFirst(this.props.action)} Group
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <Formik
          initialValues={{
            name: this.props.action === "new" ? "" : this.props.groupData.name,
          }}
          validationSchema={Yup.object().shape({
            name: Yup.string().min(3, 'Group Name Is Too Short').max(32, 'Group Name Is Too Long').concat(this.props.action === "new" ? requiredName : null),
          })}
          onSubmit={values => {
            const {onGroupsNew, onGroupsEdit} = this.props
            if (this.props.action === "new") {
              onGroupsNew({history: this.props.history, values: values})
            } else {
              onGroupsEdit({history: this.props.history, id: this.props.groupData.id, values: removeEmptyFormField(values)})
            }
          }}
        >
          {({errors, status, touched}) => (<Form>
            <div className="modal-body">
              <Row>
                <Col lg="12" className="mb-1">
                  <FormGroup>
                    <Label htmlFor="name">
                      Name
                    </Label>
                    <Field
                      id="name"
                      name="name"
                      placeholder="Enter Group Name"
                      type="text"
                      className={"form-control" + (errors.name && touched.name ? " is-invalid" : "")}
                    />
                    <ErrorMessage
                      name="name"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
            <div className="modal-footer">
              {this.state.loading && (<div className="spinner-border text-primary m-1 me-auto" role="status">
                <span className="sr-only">Loading...</span>
              </div>)}
              {this.state.error.length > 0 && (<Alert color="danger" role="alert" className="me-auto">
                {this.state.error}
              </Alert>)}
              <Button color="secondary" onClick={this.onClose} data-dismiss="modal">
                Close
              </Button>
              <Button color="primary" type="submit">
                Save
              </Button>
            </div>
          </Form>)}
        </Formik>
      </Modal>
    </React.Fragment>)
  }
}

NewModal.propTypes = {
  response: PropTypes.any,
  onGroupsNew: PropTypes.func,
  onGroupsEdit: PropTypes.func,
};

const mapStateToProps = ({Groups}) => ({
  response: Groups.responseNew,
  loading: Groups.loadingNew,
  error: Groups.errorNew,
});

const mapDispatchToProps = dispatch => ({
  onGroupsNew: data => dispatch(groupsNew(data)),
  onGroupsEdit: data => dispatch(groupsEdit(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewModal));